import React, { useState, useEffect } from "react";
import { taxServiceClient, attachmentClient } from "../../AxiosClient";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import { withTranslation } from "react-i18next";
import e from "cors";
import cache from "../../CacheClient";
const useStyles = makeStyles((theme) => ({
  container: {
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
  },
  avatarContainer: {
    // marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  userContainer: {
    marginLeft: theme.spacing(1),
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    fontSize: theme.typography.pxToRem(15),
  },
  medium: {},
  large: {
    width: theme.spacing(9),
    height: theme.spacing(9),
  },
  popover: {
    pointerEvents: "none",
    // backgroundColor: 'transparent',
    // borderRadius: theme.spacing(7),
  },
  paper: {
    // backgroundColor: 'transparent',
    borderRadius: theme.spacing(9),
    marginTop: -8,
    marginLeft: -8,
  },
}));
function DisplayUser(props) {
  const [userId] = useState(props.userId);
  const [user, setUser] = useState(props.user ? props.user : {});
  const [avatarContent, setAvatarContent] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles();

  const handlePopoverOpen = (event) => {
    avatarContent !== null && setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    avatarContent !== null && setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  useEffect(
    () => {
      !props.user &&
        props.userId &&
        taxServiceClient.get(`/user/${props.userId}`).then((res) => {
          setUser(res.data);
        });
    },
    [props.userId]
  );
  useEffect(
    () => {
      props.user &&
        props.user.hasOwnProperty("avatarURI") &&
        props.user.avatarURI &&
        props.user.avatarURI !== "images/defaultAvatar.jpg" &&
        getAvatarContent()
      setUser(props.user)
    },
    [props.user]
  );
  const getAvatarContent = () => {
    let cached = cache.get(`attachment-${props.user.avatarURI}`);
    if(!cached){
      attachmentClient
        .get(`/attachment/${props.user.avatarURI}/content/`, {
          responseType: "blob",
        })
        .then((res) => {
          let reader = new FileReader();
          reader.readAsDataURL(res.data);
          reader.onloadend = () => {
            let base64data = reader.result;
            setAvatarContent(base64data);
            cache.put(`attachment-${props.user.avatarURI}`, base64data);
          };
        })
        .catch((err) => {
          setAvatarContent(null);
        });
    } else {
      setAvatarContent(cached);
    }
  };

  const stringToColor = (string) => {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let colour = "";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      colour += `00${value.toString(16)}`.substr(-2);
    }
    /* eslint-enable no-bitwise */

    if (parseInt(colour, 16) > 15658734) return "#eeeeee";
    return `#${colour}`;
  };

  const invertColor = (hex) => {
    if (hex.indexOf("#") === 0) {
      hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
      throw new Error("Invalid HEX color.");
    }
    // invert color components
    var r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
      g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
      b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
    // pad each with zeros and return
    return "#" + padZero(r) + padZero(g) + padZero(b);
  };

  const padZero = (str, len) => {
    len = len || 2;
    var zeros = new Array(len).join("0");
    return (zeros + str).slice(-len);
  };

  const getAvatarStyles = () => {
    let backGround =
      user && user.hasOwnProperty("userLogin") && user.userLogin !== null
        ? stringToColor(user.userLogin)
        : "#eeeeee";
    let avatarStyle = {};
    avatarStyle.color = invertColor(backGround);
    avatarStyle.backgroundColor = backGround;
    return avatarStyle;
  };
  return (
    <>
      {user && user.hasOwnProperty("userLogin") && user.userLogin !== null ? (
        <>
          <div
            className={classes.container}
            aria-owns={open ? "mouse-over-popover" : undefined}
            aria-haspopup="true"
          >
            <div className={classes.avatarContainer}>
              <Avatar
                alt={
                  (user.firstName || "Unknown") +
                  " " +
                  (user.surname || "Unknown")
                }
                src={avatarContent !== null && avatarContent}
                className={
                  props.size
                    ? props.size.toLowerCase() === "large"
                      ? classes.large
                      : props.size.toLowerCase() === "small"
                        ? classes.small
                        : classes.small
                    : classes.small
                }
                style={getAvatarStyles()}
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
              >
                {user.hasOwnProperty("userLogin") &&
                user.userLogin !== null &&
                user.firstName &&
                user.surname
                  ? user.firstName.substring(0, 1) +
                    user.surname.substring(0, 1)
                  : "U"}
              </Avatar>
            </div>
            <div className={classes.userContainer}>
              {(user.firstName || "Unknown") +
                " " +
                (user.surname || "Unknown") +
                " (" +
                user.userLogin +
                ")"}
            </div>
          </div>
          <Popover
            id="mouse-over-popover"
            className={classes.popover}
            classes={{
              paper: classes.paper,
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            <Avatar
              alt={
                (user.firstName || "Unknown") +
                " " +
                (user.surname || "Unknown")
              }
              src={avatarContent !== null && avatarContent}
              className={classes.large}
              style={
                (user && user.hasOwnProperty("userLogin"))
                  ? {
                      backgroundColor:
                        user && user.userLogin !== null
                          ? stringToColor(user.userLogin)
                          : "#eeeeee",
                    }
                  : {
                      backgroundColor: "#eeeeee",
                    }
              }
            >
              {user.hasOwnProperty("userLogin") &&
              user.userLogin !== null &&
              user.firstName &&
              user.surname
                ? user.firstName.substring(0, 1) + user.surname.substring(0, 1)
                : "U"}
            </Avatar>
          </Popover>
        </>
      ) : (
        <>{props.t("global_unknown")}</>
      )}
    </>
  );
}
export default withTranslation()(DisplayUser);
